import axios from 'axios';
import { MessageBox } from 'element-ui';

// 创建axios实例
const service = axios.create({
  timeout: 180000 // 请求超时时间(180s)
});

// respone拦截器
service.interceptors.response.use(
  res => res,
  (error) => {
    const response = error.response;
    if (!response) {
      MessageBox.alert('Request timeout, Please refresh the page and try again', 'Error', { type: 'error' });
    } else {
      MessageBox.alert('Server Error', 'Error', { type: 'error' });
    }
    return Promise.reject(error);
  }
);

export default service;
